import { createStyles, makeStyles } from '@hawkins/styles';
// The max widths and aspect ratios for each `ErrorState` size come from the design specs in Figma.
var maxWidth = {
    LARGE: 1144,
    MEDIUM: 912,
    SMALL: 448,
};
export function errorStateStyles(theme) {
    var hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name of the element containing the application logo. */
        appLogoContainer: {
            marginBottom: hawkinsVariables.spacings.space1,
        },
        /** Class name of the element containing the main content. */
        contentContainer: {
            alignItems: 'flex-start',
            display: 'flex',
            flexDirection: 'column',
            gap: hawkinsVariables.spacings.space3,
            width: '50%',
            '$rootLarge &': { gap: hawkinsVariables.spacings.space5 },
            '$rootSmall &': {
                alignItems: 'center',
                width: 'auto',
            },
        },
        /** Class name of the illustration. */
        illustration: {
            maxHeight: '100%',
            maxWidth: '100%',
        },
        /** Class name of the element containing the illustration. */
        illustrationContainer: {
            alignItems: 'center',
            display: 'flex',
            flexGrow: 1,
            height: '100%',
            justifyContent: 'center',
            '$rootSmall &': { height: '50%' },
        },
        /** Class name of the root element. */
        root: {
            alignItems: 'center',
            display: 'flex',
            maxHeight: '100%',
        },
        /** Class name of the root element when the component size is large. */
        rootLarge: {
            aspectRatio: "".concat(maxWidth.LARGE, " / 488"),
            maxWidth: maxWidth.LARGE,
        },
        /** Class name of the root element when the component size is medium. */
        rootMedium: {
            aspectRatio: "".concat(maxWidth.MEDIUM, " / 384"),
            maxWidth: maxWidth.MEDIUM,
        },
        /** Class name of the root element when the component size is small. */
        rootSmall: {
            aspectRatio: "".concat(maxWidth.SMALL, " / 527"),
            flexDirection: 'column-reverse',
            maxWidth: maxWidth.SMALL,
        },
        /** Class name of the subtitle. */
        subtitle: {
            display: 'flex',
            justifyContent: 'flex-start',
            '$rootSmall &': {
                justifyContent: 'center',
                textAlign: 'center',
            },
        },
        /** Class name of the title. */
        title: {
            display: 'flex',
            justifyContent: 'flex-start',
            '$rootSmall &': {
                justifyContent: 'center',
                textAlign: 'center',
            },
        },
    });
}
export var useErrorStateStyles = makeStyles(errorStateStyles, { name: 'Hawkins-ErrorState' });
